import BrandItemMainAdmin from './BrandItemMainAdmin';

export default BrandItemMainAdmin;
